<template>
  <div>
    <div class="filterWrapper___1wvrf">
      <div class="filterItem___3bwcm">
        <span class="title___1vMKn">分类选择：</span>
        <div class="filterRight___24f-6">
          <span
            v-for="(item, index) in allList"
            :key="item.egId"
            @click="egListTab(item, index)"
            class="itemText___1N3zE"
            :class="item.isSelect ? 'itemActive___u02fW' : ''"
          >
            {{ item.egName }}
          </span>
        </div>
        <!--<div class="btn_sel">-->
        <!--<span  @click="toMore(0)" class="resize">重置</span>-->
        <!--<span  @click="toMore(1)" class="query">查询</span>-->
        <!--</div>-->
      </div>
    </div>
    <div class="content___1ZfD3" v-if="!isShow">
      <div class="banner">
        <i-banner :list="imgList" :height="392"></i-banner>
      </div>
    </div>

    <div class="livesing">
      <div class="list___wypX_" v-if="list">
        <div
          class="type_title titleWrapper___2qZKS"
          v-if="list.lives_ing.length > 0"
        >
          <h1 class="live_type" style="color: #a5c241">直播中</h1>
        </div>
        <div class="item_list">
          <div
            class="container_item courseRecomItem___3hA2S"
            v-for="(item, index) in list.lives_ing"
            :key="'livesing' + index"
          >
            <div class="con" @click="toDetails(item.lId)">
              <div class="img-wrap">
                <div style="position: relative">
                  <div v-if="checkUserMember">
                    <get-vip-img v-if="item.lIsvipfree == 1"></get-vip-img>
                  </div>

                  <img
                    class="con_images"
                    :src="item.lPicUrl"
                    alt=""
                    v-if="item.lPicUrl"
                  />
                  <img
                    class="con_images"
                    src="../../assets/images/default.png"
                    alt=""
                    v-else
                  />
                </div>
              </div>
              <div class="con_right">
                <p class="con_title">{{ item.lTitle }}</p>
                <div class="con-a-wrap">
                  <p class="con_author">{{ item.lSpeaker }}</p>
                  <!-- <div class="view-count">{{ item.lViewCount }}人观看</div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="backg">
      <div class="content___1ZfD3">
        <div class="list___wypX_">
          <div
            class="type_title titleWrapper___2qZKS"
            v-if="list.lives_will.length > 0"
          >
            <h1 class="live_type" style="color: #ffb441">即将直播</h1>
          </div>
          <div class="item_list">
            <div
              class="liveswill"
              v-for="(item, index) in list.lives_will"
              :key="'liveswill' + index"
            >
              <p class="item_title">
                <span class="title_name">
                  <span>{{ item.group.egName }}频道</span>
                  <span class="title_time">{{ getTimes(item.lDt) }}</span>
                </span>
              </p>
              <div class="con" @click="toDetails(item.lId)">
                <div class="img-wrap">
                  <div style="position: relative">
                    <div v-if="checkUserMember">
                      <get-vip-img v-if="item.lIsvipfree == 1"></get-vip-img>
                    </div>
                    <img
                      class="con_images"
                      :src="item.lPicUrl"
                      alt=""
                      v-if="item.lPicUrl"
                    />
                    <img
                      class="con_images"
                      src="../../assets/images/default.png"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div class="con_right">
                  <p class="con_title">{{ item.lTitle }}</p>
                  <div class="con-a-wrap">
                    <p class="con_author">{{ item.lSpeaker }}</p>
                    <!-- <div class="view-count">{{ item.lViewCount }}人观看</div> -->
                  </div>
                </div>
              </div>
              <div class="last">
                <span>预约人数：{{ item.lAppointNum }}人</span>
                <button
                  class="footer_yybm"
                  @click="signUp(item.lIsAppoint, index, item.lId)"
                  :style="{
                    background: item.lIsAppoint == 1 ? '#999999' : '#FFB441',
                  }"
                >
                  {{ item.lIsAppoint == 1 ? "已预约" : "预约报名" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="livesed">
      <div>
        <div class="list___wypX_">
          <div
            class="type_title titleWrapper___2qZKS"
            v-if="list.lives_ed.length > 0"
          >
            <h1 class="live_type">直播回顾</h1>
          </div>
          <div class="item_list">
            <div
              class="liveswill"
              v-for="(item, index) in list.lives_ed"
              :key="'liveswill' + index"
            >
              <p class="item_title">
                <span class="title_name">
                  <span>{{ item.group.egName }}频道</span>
                  <span class="title_time">{{ getTimes(item.lDt) }}</span>
                </span>
              </p>
              <div class="con" @click="toDetails(item.lId,'ed')">
                <div class="img-wrap">
                  <div style="position: relative">
                    <div v-if="checkUserMember">
                      <get-vip-img v-if="item.lIsvipfree == 1"></get-vip-img>
                    </div>
                    <img
                      class="con_images"
                      :src="item.lPicUrl"
                      alt=""
                      v-if="item.lPicUrl"
                    />
                    <img
                      class="con_images"
                      src="../../assets/images/default.png"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div class="con_right">
                  <p class="con_title">{{ item.lTitle }}</p>
                  <div class="con-a-wrap">
                    <p class="con_author">{{ item.lSpeaker }}</p>
                    <div class="view-count">{{ item.lViewCount }}人观看</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        list.lives_will.length < 1 &&
        list.lives_ed.length < 1 &&
        list.lives_ing.length < 1
      "
      class="nothing"
    >
      <img src="../../assets/images/nonelist.png" alt="" />
      <div>暂无数据</div>
    </div>
  </div>
</template>
<script>
import iBanner from "../container/banner";
import weui from "weui.js";
import iVideolist from "../container/videoList";
import GetVipImg from "../getvipimg/getVipImg.vue";
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';

export default {
  data() {
    return {
      checkUserMember: true,
      imgList: [],
      isShow: false,
      list: {
        lives_will: [],
        lives_ing: [],
        lives_ed: [],
      },
      videos: [],
      uid: "",
      ra_wxUser: null,
      allList: [],
    };
  },
  props: {},
  created() {
    this.$waiting.show(3);
  },
  methods: {
    getUser() {
      let type = this.ra_wxUser && this.ra_wxUser.uMemberType;
      if (type == 1 || type == 2) {
      }
      console.log(
        "----------------------------" +
          this.ra_wxUser.uMemberType +
          "   " +
          this.ra_wxUser.uName
      );
    },
    toMore() {
      let eglist = this.allList.filter((v) => v.isSelect);
      let eg_ids = [];
      if (eglist.length) {
        eglist.map((item) => {
          eg_ids.push(item.egId);
        });
      }
      this.isShow = true;
      let message = {
        uid: this.ra_wxUser
          ? this.ra_wxUser.uId
            ? this.ra_wxUser.uId
            : ""
          : "",
        eg_ids: eg_ids,
        img_type: 2,
      };
      this.$postHttp(AppSetting.baseUrl + "/live/student/list", message).then((res) => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;
          this.imgList = data.pictures;
        }
      });
    },

    egListTab(res, index) {
      let item = res;
      item.isSelect = !item.isSelect;
      this.$set(this.allList, index, item);
      setTimeout(() => {
        this.toMore(1);
      }, 500);
    },
    getList() {
      this.$postHttp(AppSetting.baseUrl + "/common/entgroup/info", {}).then((res) => {
        console.log("类型");
        console.log(res);
        if (res.data.code == 0) {
          let data = res.data.list;
          this.allList = data;
          this.allList.map((item) => {
            item.isSelect = false;
          });
        }
      });
    },
    getData() {
      let message = {
        uid: this.ra_wxUser
          ? this.ra_wxUser.uId
            ? this.ra_wxUser.uId
            : ""
          : "",
        img_type: 2,
      };
      this.$postHttp(AppSetting.baseUrl + "/live/student/list", message).then((res) => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.list = data;
          this.imgList = data.pictures;
        }
      });
    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails(id,type) {
      // type  ed 代表直播回顾 有用户在支付是需要展示 多一行的提示语 “购买后有效期半年可看”
      localStorage.setItem("userLiveId", id);
      localStorage.setItem("usertype", 1);
      if(type) {
        this.$router.push({
        name: "Details",
        query: { type: "live", liveId: id, tip:type },
      });
      } else {
        this.$router.push({
          name: "Details",
          query: { type: "live", liveId: id,},
        });
      }
    },

    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
      });
    },
    async signUp(status, index, lid) {
      localStorage.setItem("userLiveId", lid);
      localStorage.setItem("usertype", 1);
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        if (status == 0) {
          this.$postHttp(AppSetting.baseUrl + "/live/appointment", {
            uid: this.ra_wxUser
              ? this.ra_wxUser.uId
                ? this.ra_wxUser.uId
                : ""
              : "",
            lid: lid,
          }).then((res) => {
            if (res.data.code == 0) {
              this.$set(this.list.lives_will[index], "lIsAppoint", 1);
              this.$set(
                this.list.lives_will[index],
                "lAppointNum",
                res.data.num
              );
              //参数：要改的对象、要改的key 、要改的值

              this.$message({
                message: "预约成功",
                type: "success",
              });
            } else {
              this.$message.error("预约失败");
            }
          });
        } else {
          weui.dialog({
            content: "确定要取消预约吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => {
                  // alert('取消')
                },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/live/appointment/cancel", {
                    uid: this.ra_wxUser
                      ? this.ra_wxUser.uId
                        ? this.ra_wxUser.uId
                        : ""
                      : "",
                    lid: lid,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.$set(this.list.lives_will[index], "lIsAppoint", 0);
                      this.$set(
                        this.list.lives_will[index],
                        "lAppointNum",
                        res.data.num
                      );

                      this.$message({
                        message: "取消成功",
                        type: "success",
                      });
                    } else {
                      this.$message.error("取消预约失败");
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },
  },
  components: {
    iBanner,
    iVideolist,
    GetVipImg,
  },
  async mounted() {
    this.ra_wxUser=await loginService.getLoginUser();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.getData();
    this.getList();
  },
};
</script>
<style scoped lang="scss">
.search_top {
  overflow: hidden;
  width: 1280px;
}

.search_con {
  float: right;
  border-radius: 50%;
  margin-top: 20px;

  .search___1FrwO {
    border: 1px solid #e6e6e6;
  }
}

.btn_sel {
  margin-left: 300px;
  line-height: 39px;

  span {
    width: 100px;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    background: #ffb441;
    text-align: center;
    color: #ffffff;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
  }

  .resize {
    background: #e6e6ea;
  }

  .query {
    margin-left: 30px;
  }
}

.filterWrapper___1wvrf {
  margin-bottom: 20px;
  background: #fff;
  -webkit-box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
}

.filterItem___3bwcm {
  width: 1280px;
  min-width: 1176px;
  border-bottom: 1px dashed #ebebeb;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  padding: 25px 0 6px;

  .title___1vMKn {
    font-size: 14px;
    float: left;
    line-height: 27px;
    color: #999;
    min-width: 70px;
    height: 30px;
    margin-right: 25px;
  }

  .filterRight___24f-6 {
    display: flex;
    flex-wrap: wrap;
    line-height: 27px;

    span {
      font-size: 14px;
      cursor: pointer;
      padding: 2px 12px;
    }
  }

  .itemText___1N3zE {
    min-height: 20px;
    color: #333;
    margin-right: 8px;
    cursor: pointer;
    margin-bottom: 10px;
  }

  .itemActive___u02fW {
    border-radius: 16px;
    background-color: #ffb441;
    color: #fff;
    text-align: center;
    box-sizing: border-box;
  }
}

.search___1FrwO {
  position: relative;
  width: 296px;
  height: 36px;
  border-radius: 18px;
  /*background: #f2f2f2;*/
  background: #ffffff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;

  .searchBox___joiqa {
    outline: none;
    border: none;
    -ms-flex: 1 1;
    flex: 1 1;
    /*background: #f2f2f2;*/
    background: #ffffff;
    height: 36px;
    padding-left: 27px;
    font-size: 14px;
    color: #999;
    line-height: 20px;
    border-radius: 18px;
    -webkit-appearance: none;
  }

  .iconWrapper___3GNet {
    cursor: pointer;
    width: 56px;
    height: 36px;
    background-image: linear-gradient(-179deg, #ffb441, #ffb441);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-top-right-radius: 18px;
    border-bottom-right-radius: 18px;

    .icon {
      font-size: 26px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.livesing {
  width: 100%;
  min-width: 1280px;

  > div {
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
  }
}

.livesed {
  width: 100%;
  min-width: 1280px;
  margin-bottom: 50px;

  > div {
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
  }
}

.qcode {
  position: fixed;
  width: 1rem;
  height: 1rem;
  /*border-radius: 50%;*/
  bottom: 1.5rem;
  right: 0.1rem;
}

.title___2jv0H {
  flex: 1 1;
  font-size: 26px;
  font-weight: 500;
  color: #333;
}

.footer_yybm {
  width: 60px;
  font-size: 12px;
  cursor: pointer;
}

.abc {
  position: relative;
}

.abc img {
  display: block;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  /*width: 7rem;*/
  /*margin: 0.25rem;*/
}

.mask {
  position: fixed;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
}

.rel {
  font-size: 0.28rem;

  .qrcode {
    width: 6.9rem;
    /*height: 3.57rem;*/
    background: #ffffff;
    top: 2.21rem;
    position: absolute;
    left: 0.32rem;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0.4rem 0.3rem;
    box-sizing: border-box;
    z-index: 11;

    p {
      text-align: center;
      font-size: 0.4rem;
    }
  }
}

.search {
  height: 1.1rem;
  display: flex;
  align-items: center;
  padding: 0 0.3rem;
  box-sizing: border-box;
  background: #f7f7f7;

  > img {
    width: 2.79rem;
    height: 0.38rem;
  }

  > div {
    display: flex;
    width: 3.8rem;
    height: 0.7rem;
    border: 1px solid #ffb441;
    padding-left: 0.2rem;
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 10px;
    margin-left: 0.32rem;
    font-size: 0.3rem;
    color: #ffb441;
    align-items: center;
    justify-content: center;

    img {
      width: 0.4rem;
      height: 0.37rem;
      margin-right: 0.15rem;
    }
  }
}

.content___1ZfD3 {
  width: 1280px;
  min-width: 1280px;
  box-sizing: border-box;
  margin: 0 auto;
}

.backg {
  width: 100%;
  min-width: 1280px;
}

.nothing {
  width: 100%;
  box-sizing: border-box;
  text-align: center;

  img {
    width: 100px;
    display: inline-block;
    margin: 80px auto 0;
  }

  div {
    font-size: 26px;
    color: #999999;
    text-align: center;
  }
}

.banner {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05),
    -3px 0 5px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px 0 5px rgba(0, 0, 0, 0.05);
}

.titleWrapper___2qZKS {
  /*margin-top: 46px;*/
}

.item_list {
  overflow: hidden;
  margin-bottom: 20px;
}

.img-wrap {
  width: 210px;
  height: 118px;
  display: flex;
  align-items: center;
}

.container_item {
  /*border: 1px solid #999999;*/
  /*-webkit-border-radius: 5px;*/
  /*padding: 10px;*/
  -moz-border-radius: 5px;
  border-radius: 5px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 232px;
  /*height: 207px;*/
  cursor: pointer;
  background: #fff;
  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .item_title {
    .title_name {
      font-size: 12px;
      color: #666666;
    }

    .title_time {
      color: #999999;
    }
  }

  .con {
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    padding: 10px;

    .con_right {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .con_images {
      width: 210px;
      //max-width: 100%;
      max-height: 118px;
      border-radius: 5px;
    }

    .con_title {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      height: 44px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
  }

  .con_org {
    font-size: 12px;
    color: #999;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.courseRecomItem___3hA2S {
  /*height: 207px;*/
}

.type_title {
  box-sizing: border-box;
}

.last {
  display: flex;
  justify-content: space-between;

  span:nth-of-type(1) {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 12px;
  }
}

.last,
.type_title {
  button {
    border-radius: 25px;
    color: #ffffff;
    border: none;
    outline: none;
  }
}

.footer_type {
  color: #ffb400;
}

.textColor {
  color: #2bcf4a;
}

.live_type {
  flex: 1 1;
  font-size: 26px;
  font-weight: 500;
  color: #007eff;
  margin-top: 26px;
}

.liveswill {
  border: 1px solid #e6e6e6;
  height: 264px !important;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  padding: 0 10px;

  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;

  .con {
    margin-top: 6px;
  }

  .item_title {
    padding-top: 6px !important;
  }

  .title_name {
    font-size: 12px;
    color: #666666 !important;
    display: flex;
    justify-content: space-between;

    span:nth-of-type(1) {
      width: 110px;
      display: inline-block;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1; /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden; /*超出隐藏*/
      text-overflow: ellipsis; /*文本超出显示省略号*/
    }
  }

  .con_images {
    width: 210px;
    max-width: 100%;
    //height: 134px !important;
    //max-height: 100%;
    max-height: 118px;
    border-radius: 5px;
  }

  .con_title {
    font-size: 14px !important;
    color: #333 !important;
    line-height: 18px !important;
    height: 39px !important;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2; /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    //margin-top: 5px !important;
  }

  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
  }
}

.con-a-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;

  .view-count {
    font-size: 12px;
    font-width: 300;
    color: #ea3223;
  }

  .con_author {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/live/index.vue